import { Link } from "react-router-dom";
import { ChevronLeft, Users } from "lucide-react";
import { PLATFORM_NAME } from "@/lib/api";
import { homeFor } from "@/lib/community";

/** The chauffeur app and the owner console have no sidebar, so the community pages carry their own
 *  slim header and a way back to the app they were opened from. */
export const CommunityFrame = ({ children }) => (
  <div data-testid="community-frame" className="min-h-screen bg-ink-900 text-slate-200">
    <header className="glass-header sticky top-0 z-40 border-b border-ink-600">
      <div className="mx-auto flex h-16 max-w-4xl items-center justify-between gap-3 px-4">
        <Link to={homeFor()} data-testid="community-frame-back"
          className="flex items-center gap-1.5 text-sm text-slate-400 transition-colors hover:text-gold">
          <ChevronLeft className="h-4 w-4" /> Back
        </Link>
        <div className="flex items-center gap-2 text-gold">
          <Users className="h-4 w-4" />
          <p className="font-mono text-[10px] uppercase tracking-widest">{PLATFORM_NAME} community</p>
        </div>
      </div>
    </header>
    <main className="mx-auto max-w-4xl px-4 py-5 pb-28">{children}</main>
  </div>
);
